// extracted by mini-css-extract-plugin
export default {"product":"productCarousel_product__KJjGS","preProduct":"productCarousel_preProduct__yhYEX"};